import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { customSpecSchema } from '@/components/reports/custom/spec-schema';
import { ReportsPage } from '@/components/reports/reports-page';
import {
  RANKING_METRICS,
  REPORT_PLATFORMS,
} from '@/components/reports/shared/report-filter';
import { ALL_REPORT_TYPES } from '@/components/reports/shared/report-type-labels';
import { DATE_RANGE_VALUES } from '@/lib/date-range';
import { CampaignIntent, ClaimWindow } from '@/types/generated/enums';

const searchSchema = z.object({
  report_type: z.enum(ALL_REPORT_TYPES).default('org_performance'),
  date_range: z.enum(DATE_RANGE_VALUES).default('LAST_30D'),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  strategy_id: z.coerce.number().int().positive().optional(),
  platform: z.enum(REPORT_PLATFORMS).optional(),
  intent: z.nativeEnum(CampaignIntent).optional(),
  metric: z.enum(RANKING_METRICS).optional(),
  limit: z.coerce.number().int().min(1).max(50).optional(),
  columns: z.array(z.enum(RANKING_METRICS)).optional(),
  claim_window: z.nativeEnum(ClaimWindow).optional(),
  spec: customSpecSchema.optional(),
});

export const Route = createFileRoute('/_authenticated/reports/')({
  validateSearch: searchSchema,
  staticData: {
    title: 'route.reports.title',
    messageContext: { context_type: 'reports' },
  },
  component: ReportsPage,
});
